module.exports = __webpack_public_path__ + "media/fresh/loans-a50b2d6f.svg";